import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';

import Question from './Question';
import './GridInfo.scss';
import { tooltipDataList } from './constant';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';
import { BaseCard } from '@bvt-shared/component/BaseCard';

/**
 * GridInfo
 * @param {object} props
 * @param {boolean} props.isDashboard
 * @param {string} props.grade
 * @param {string} props.grid
 * @param {string} props.size
 * @param {string} props.center
 * @param {string} props.acceptable
 * @param {string} props.min
 * @param {string} props.max
 * @param {string} props.totalScore
 */

export default function GridInfo(props) {
  const { grid, size, center, acceptable, isDashboard, min, max, totalScore } =
    props;
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleTooltipClicked = () => {
    setIsTooltipVisible((prev) => {
      return !prev;
    });
  };

  const contentTooltip = (
    <Swiper className='mySwiper' modules={[Pagination]} pagination={true}>
      <SwiperSlide>
        <div>
          {tooltipDataList.firstSlide.map((data) => (
            <div className='content-tooltip' key={data.id}>
              <div className='heading-tooltip'>
                <span className='icon-tooltip'>
                  <IconTooltip
                    primaryColor={data.iconPrimaryColor}
                    secondaryColor={data.iconSecondaryColor}
                  />
                </span>
                <span className='title-tooltip'>{data.title}</span>
              </div>
              <div className='text-content-tooltip'>{data.text_content}</div>
            </div>
          ))}
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div>
          {tooltipDataList.secondSlide.map((data) => (
            <div className='content-tooltip' key={data.id}>
              <div className='heading-tooltip'>
                <span className='icon-tooltip'>
                  <IconTooltip primaryColor={data.iconPrimaryColor} />
                </span>
                <span className='title-tooltip'>{data.title}</span>
              </div>
              <div className='text-content-tooltip'>{data.text_content}</div>
            </div>
          ))}
        </div>
      </SwiperSlide>
    </Swiper>
  );

  const gridRow = {
    grid: 'Grid',
    size: 'Size',
    center: 'Center',
    acceptable: 'Acceptable',
    min: 'Min. Acceptable Score',
    max: 'Max. Acceptable Score',
    score: 'Grid Score',
  };

  const getColor = {
    'Acceptable 1': '#33CC66',
    'Acceptable 2': '#FFEB99',
    'Acceptable 3': '#FF9966',
    'Acceptable 4': '#FF0066',
    Unacceptable: '#657991',
  };

  let infoContent = (
    <>
      <Row>
        <Col span={8}>{gridRow.grid}</Col>
        <Col className='text-bold' span={14}>
          {grid}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.size}</Col>
        <Col className='text-bold' span={14}>
          {size}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.center}</Col>
        <Col className='text-bold' span={14}>
          {center}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.acceptable}</Col>
        <Col className='text-bold' span={14}>
          {acceptable}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.min}</Col>
        <Col className='text-bold' span={14}>
          {min}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.max}</Col>
        <Col className='text-bold' span={14}>
          {max}
        </Col>
      </Row>
      <Row>
        <Col span={8}>{gridRow.score}</Col>
        <Col className='text-bold' span={14}>
          {totalScore}
        </Col>
      </Row>
    </>
  );

  if (isDashboard) {
    infoContent = (
      <>
        <Row>Grid ID</Row>
        <Row className='text-bold'>{grid}</Row>
        <Row>
          <Col span={6}>Color</Col>
          <Col className='text-bold color_col' span={18}>
            <span
              className='color_val'
              style={{
                backgroundColor: getColor[acceptable] || '#11D956',
                opacity: 0.4,
              }}
            />
            <span className='tooltip-container'>
              {isTooltipVisible && (
                <div className='tooltip'>
                  <button
                    className='button-tooltip'
                    onClick={handleTooltipClicked}
                    type='button'
                  >
                    <svg
                      height='1rem'
                      viewBox='0 0 12.263 12.263'
                      width='12.263'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M3.153,7.489V5.518H1.183a1.182,1.182,0,1,1,0-2.364h1.97V1.183a1.183,1.183,0,1,1,2.365,0V3.154H7.489a1.182,1.182,0,1,1,0,2.364H5.518V7.489a1.183,1.183,0,1,1-2.365,0Z'
                        data-name='Union 24'
                        fill='#616477'
                        id='Union_24'
                        transform='translate(6.132) rotate(45)'
                      />
                    </svg>
                  </button>
                  {contentTooltip}
                  <div className='triangle-tooltip' />
                </div>
              )}
              <button
                className='tooltip-icon'
                onClick={handleTooltipClicked}
                type='button'
              >
                <Question />
              </button>
            </span>
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.size}</Col>
          <Col className='text-bold' span={18}>
            {size}
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.center}</Col>
          <Col className='text-bold' span={18}>
            {center}
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.acceptable}</Col>
          <Col className='text-bold' span={18}>
            {acceptable}
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.min}</Col>
          <Col className='text-bold' span={14}>
            {min}
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.max}</Col>
          <Col className='text-bold' span={14}>
            {max}
          </Col>
        </Row>
        <Row>
          <Col span={6}>{gridRow.score}</Col>
          <Col className='text-bold' span={14}>
            {totalScore}
          </Col>
        </Row>
      </>
    );
  }

  const content = (
    <div className={isDashboard ? 'features_gridInfo' : ''}>{infoContent}</div>
  );

  return (
    <div id='GrianaDashboardGridInfo' style={props?.style}>
      <BaseCard
        isLoading={props?.isLoading}
        title='Grid Information'
        withPadding={true}
      >
        {content}
      </BaseCard>
    </div>
  );
}

function IconTooltip({ primaryColor }) {
  return (
    <svg
      data-name='Component 511 – 1'
      height='17'
      id='Component_511_1'
      viewBox='0 0 17 17'
      width='17'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        data-name='Rectangle 5966'
        fill={primaryColor}
        id='Rectangle_5966'
        opacity='0.4'
        stroke='#fff'
        strokeWidth='1'
      >
        <rect height='17' stroke='none' width='17' />
        <rect fill='none' height='16' width='16' x='0.5' y='0.5' />
      </g>
    </svg>
  );
}

GridInfo.defaultProps = {
  acceptable: 'Acceptable 1',
  center: '106.6100177018, -6.2091623773',
  grade: 'A',
  grid: '1405448',
  isDashboard: false,
  size: '1 Km',
};

GridInfo.propTypes = {
  acceptable: PropTypes.string,
  center: PropTypes.string,
  grade: PropTypes.string,
  grid: PropTypes.string,
  isDashboard: PropTypes.bool,
  max: PropTypes.string,
  min: PropTypes.string,
  size: PropTypes.string,
  totalScore: PropTypes.string,
};
